const scriptLoads = new Map<string, Promise<void>>();

/** Share one load and readiness promise per script across all integrations. */
export function loadScript(src: string, attributes: Record<string, string> = {}): Promise<void> {
  const existing = scriptLoads.get(src);
  if (existing) return existing;

  const loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    for (const [name, value] of Object.entries(attributes)) script.setAttribute(name, value);
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
    document.head.appendChild(script);
  });
  scriptLoads.set(src, loading);
  return loading;
}
